import React from 'react';
import { useAuth } from './AuthProvider';
import { useState } from 'react';
import { ChevronDown, LogOut, UserCog, ExternalLink } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const AuthComponent: React.FC = () => {
    const { user, login, logout } = useAuth();
    const [isOpen, setIsOpen] = useState(false);

    if (!user) {
        return (
            <div className="flex flex-col items-center justify-center p-4">
                <button
                    onClick={login}
                    className="flex items-center gap-2 px-4 py-2 text-white bg-gray-900 rounded-lg hover:bg-blue-600 transition-colors"
                >
                    <svg
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill="currentColor"
                            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        />
                        <path
                            fill="currentColor"
                            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        />
                        <path
                            fill="currentColor"
                            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        />
                        <path
                            fill="currentColor"
                            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        />
                    </svg>
                    Sign in
                </button>
            </div>
        );
    }

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
                {user.imageUrl ? (
                    <img
                        src={user.imageUrl}
                        alt={user.displayName}
                        className="w-8 h-8 rounded-full object-cover border border-gray-200"
                    />
                ) : (
                    <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white">
                        {user.displayName && user.displayName.charAt(0) || '?'}
                    </div>
                )}
                <span className="font-medium">{user.displayName}</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 py-2 bg-white rounded-lg shadow-lg border border-gray-200">
                    {user.username &&
                        <Link
                            to={`/${user.username}`}
                            className="w-full flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
                            onClick={() => setIsOpen(false)}
                        >
                            <ExternalLink className="w-4 h-4" />
                            <span>View Profile</span>
                        </Link> ||
                        <Link
                            to={`/register-user`}
                            className="w-full flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
                            onClick={() => setIsOpen(false)}
                        >
                            <ExternalLink className="w-4 h-4" />
                            <span>Set up profile</span>
                        </Link>
                    }
                    <Link
                        to="/edit-user"
                        className="w-full flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
                        onClick={() => setIsOpen(false)}
                    >
                        <UserCog className="w-4 h-4" />
                        <span>Edit Profile</span>
                    </Link>
                    <div className="border-t border-gray-200 my-1"></div>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            logout();
                        }}
                        className="w-full flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        <LogOut className="w-4 h-4" />
                        <span>Sign out</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default AuthComponent;